import type { PageConfig } from '../types';

export const activityPageConfig: PageConfig = {
  id: 'activity',
  tabLabel: 'Activity',
  sections: [
    {
      id: 'hero',
      titleFromMetric: true,
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'personalized_touchpoints', span: 'full' }],
    },
    {
      id: 'activity-stats',
      layout: 'grid-3',
      items: [
        { kind: 'metric', id: 'buyer_profile_count' },
        { kind: 'metric', id: 'engagement_rate' },
        { kind: 'metric', id: 'unsubscribe_rate' },
      ],
    },
    {
      id: 'content-performance',
      overline: 'CONTENT PERFORMANCE',
      titleFromMetric: true,
      actions: [{ label: 'See full breakdown', navigation: { type: 'L2' } }],
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'content_theme_sent_count', span: 'full' }],
    },
    
  ],
};
